import {Component} from 'react';
import h from 'react-hyperscript';
import {p, eyebrow, subhead} from 'Components/Typography/Typography';
import BasicCard from 'Components/Cards/BasicCard';
// eslint-disable-next-line max-len
import SurveyMessaging from 'Pages/ReportCardOverview/SurveyReportStatus/SurveyMessaging/SurveyMessaging';
import {replaceReportNamePlaceholder} from 'Src/utils/utils';

class ReportAvailableState extends Component {
  sanitize(string) {
    const reportName = this.props.latestReport.report_card_name;
    return replaceReportNamePlaceholder(string, reportName);
  }

  render() {
    const subtitle = this.props.content.subtitle;
    const nextReportDate = new Date(this.props.nextSurveyDate);
    return h(
        BasicCard,
        {
          type: 'basic',
          className: 'report-overview__status status--no-report flex',
          id: `report-overview--${this.props.content.statusId}`,
        },
        h(
            'div',
            {
              className: 'flex--space-between flex--wrap',
            },
            [
              h(
                  SurveyMessaging,
                  {
                    title: this.sanitize(this.props.content.title),
                    missingData: this.props.data[0].missing_data,
                    SubtitleComponent: h(
                        p,
                        {
                          key: `survey-messaging-subtitle.partOne}`,
                          className: 'text--grey survey-messaging__subtitle',
                          dangerouslySetInnerHTML: subtitle,
                        },
                        null,
                    ),
                    ctas: this.props.content.ctas,
                    statusId: this.props.content.statusId,
                    latestReport: this.props.latestReport,
                    districtId: this.props.userStatus.district_id,
                    userStatus: this.props.userStatus,
                    shareInfo: this.props.shareInfo,
                  },
                  null
              ),
              h(
                  'div',
                  {
                    className: 'col-ratio-1 report-overview__sidebar',
                  },
                  [
                    h(eyebrow, null, 'Next Report Available'),

                    h(
                        'div',
                        {className: 'padding-bottom--md'},
                        h(
                            subhead,
                            {
                              className: 'flex',
                            },
                            nextReportDate.toLocaleString('default',
                                {month: 'long', year: 'numeric'})
                        )
                    ),
                  ]
              ),
            ]
        )
    );
  }
}

export default ReportAvailableState;
